import axios from "axios";
import { settings } from "../../main/configs/settings";
import ICNPJInformation from "../../domain/models/integration-cnpj";



export class HelperCnpjInformaton {
  static async getInformationCnpj(cnpj: string): Promise<Partial<ICNPJInformation> | null> {
    const baseApiUrl = `${settings.API_URL}/public/integration/check-cnpj/${cnpj}`;

    try {
      const response = await axios.get(baseApiUrl);
      const {
        updated,
        taxId,
        alias,
        founded,
        head,
        company,
        statusDate,
        status,
        address,
        mainActivity,
        phones,
        emails,
        sideActivities,
        registrations,
        suframa
      } = response.data;
      
      return {
        updated,
        taxId,
        alias,
        founded,
        head,
        company,
        statusDate,
        status,
        address,
        mainActivity,
        phones,
        emails,
        sideActivities,
        registrations,
        suframa
      };
      
    } catch (error) {
      return {
        updated: "",
        taxId: "",
        alias: "",
        founded: "",
        head: false,
        company: {
          id: 0,
          name: "",
          equity: 0,
          nature: { id: 0, text: "" },
          size: { id: 0, acronym: "", text: "" },
          simples: { optant: false, since: null },
          simei: { optant: false, since: null },
          members: []
        },
        statusDate: "",
        status: { id: 0, text: "" },
        address: {
          municipality: 0,
          street: "",
          number: "",
          district: "",
          city: "",
          state: "",
          details: null,
          zip: "",
          country: { id: 0, name: "" }
        },
        mainActivity: { id: 0, text: "" },
        phones: [],
        emails: [],
        sideActivities: [],
        registrations: [],
        suframa: []
      };
    }
  }

  static isValidCnpj = (inputCnpj: string): boolean => {
    // Cria uma cópia limpa do CNPJ (evita reatribuição de parâmetro)
    const cnpj = inputCnpj.replace(/[^\d]+/g, "");
  
    if (cnpj.length !== 14) return false;
  
    // Elimina CNPJs com todos os dígitos iguais
    if (/^(\d)\1+$/.test(cnpj)) return false;
  
    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    const digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;
  
    for (let i = length; i >= 1; i -= 1) {
      const n = parseInt(numbers.charAt(length - i), 10);
      sum += n * pos;
      pos -= 1;
      if (pos < 2) pos = 9;
    }
  
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0), 10)) return false;
  
    length += 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;
  
    for (let i = length; i >= 1; i -= 1) {
      const n = parseInt(numbers.charAt(length - i), 10);
      sum += n * pos;
      pos -= 1;
      if (pos < 2) pos = 9;
    }
  
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    return result === parseInt(digits.charAt(1), 10);
  };
  
}

export default HelperCnpjInformaton;
